module.exports = __webpack_public_path__ + "img/9.c61a94c4.jpg";